/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 12 de 05 de 2026
 */

import {
    DetailsIconsOptions,
    EmailSubsectionChip,
    HeaderiEntry,
    IconButtonReportFile,
    IconClockTable,
    IconDateTimeCalendar,
    IconDeviceFixed,
    IconMarkerTable,
    IconTitleEntryMethod,
    PhoneLight
} from "../../../../../components/buttons/IconButtons";
import CustomModal from "../../../../../components/Modal/CustomModal";
import CustomCard from "../../../../../components/CustomCard";
import CustomChip from "../../../../../components/CustomChip";
import {colors} from "../../../../../enums/colors";
import React from "react";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import personDefaultV2 from "../../../../../assets/ImagesDefaults/ic-person-v2.svg";
import ImageCardGrid from "../../../../../components/ImageCardGrid";
import {
    DATE_TIME_FORMAT_MODEL,
    DATE_TIME_FORMAT_NAME_MODEL,
    getDateFormat,
    getTimeFormat
} from "../../../../../Apis/functions";
import {getAccessMethodLabel} from "../../../../../enums/accessMethodEnum";
import {DEVICE_ICON_BY_TYPE} from "../../../../../hooks/deviceTypeEnum";
import CustomTooltip from "../../../../../components/CustomTooltip";


const InfoRow = ({leftIcon: LeftIcon, leftText, rightIcon: RightIcon, rightText}) => (
    <div className="d-flex fs-14px ibl-font-w-400 font-color-shades-950 gap-2">
        <div className="d-flex align-items-center flex-fill justify-content-start min-w-0 gap-2">
            {LeftIcon && (<LeftIcon width={16} height={16} className="flex-shrink-0 mb-2px"/>)}
            <div className='d-flex flex-grow-0 minw-0'>
                <CustomTooltip
                    text={leftText}
                    classes='fs-14px ibl-font-w-400 text-ellipsis'
                    showIfTruncated
                    tooltipClasses={'d-flex'}
                    placement='top'
                />
            </div>
        </div>
        {rightText && (
            <div className="d-flex align-items-center flex-fill justify-content-end min-w-0 gap-2">
                {RightIcon && (<RightIcon width={16} height={16} className="flex-shrink-0 mb-2px"/>)}
                <div className='d-flex flex-grow-0 minw-0'>
                    <CustomTooltip
                        text={rightText}
                        classes='fs-14px ibl-font-w-400 text-ellipsis'
                        showIfTruncated
                        placement='top'
                    />
                </div>
            </div>
        )}
    </div>
);


const Section = ({title, leftIcon, leftText, rightIcon, rightText,horizontalLane = true}) => (
    <>
        <p className="fs-14px ibl-font-w-600 font-color-general-950 mb-1">{title}</p>
        <InfoRow leftIcon={leftIcon} leftText={leftText} rightIcon={rightIcon} rightText={rightText}/>
        {
            horizontalLane && <div className="border-bottom-shades-300 mt-2 mb-2"/>
        }
    </>
);

const AccessDetailsCardModal = (props) => {

    const {
        data,
        t,
        setShowReportModal,
        onHide
    } = props;

    const IconDevice = DEVICE_ICON_BY_TYPE[data?.entryDeviceTypeId] || IconDeviceFixed;
    const imagePreview = data?.image ? `data:image/png;base64,${data?.image}` : personDefaultV2;

    return (
        <CustomModal
            {...props}
            buttonConfirm="confirm"
            size="lg"
            cancelButton={false}
            confirmButton={false}
            topLeftHeader={
                <div className="d-flex align-items-center pb-3">
                    <DetailsIconsOptions/>
                    <p className="fs-24px ibl-font-w-600 font-color-general-950 font-color-primary-600 ml-2">
                        {t("details")}
                    </p>
                    <div className="vertical-separator h-auto"/>
                </div>
            }
            classNameBody="pt-2"
        >
            <CustomCard classCard="card-border-8px" classContent="p-0">
                <HeaderiEntry className="w-100 h-100"/>
                <div className="d-flex justify-content-between align-items-center p-12px">
                    <div className="d-flex align-items-center p-3">
                        <IconTitleEntryMethod/>
                        <div className="ml-2">
                            <p className="font-color-general-950 ibl-font-w-600 fs-14px">{t("access_log")}</p>
                        </div>
                        <div className="vertical-separator-shades-950 h-36px d-none d-md-block"/>

                        <CustomChip
                            legend={t(data?.success ? "authorized" : "denied")}
                            background={data?.success ? colors.success100 : colors.errorCode100}
                            fontColor={data?.success ? colors.success700 : colors.errorCode700}
                            borderColor={data?.success ? colors.success150 : colors.errorCode150}
                        />
                    </div>

                    <ButtonAction
                        id="btn_adcm_report"
                        name="report"
                        className="btn-icon-delete"
                        Icon={IconButtonReportFile}
                        onClick={() => {
                            setShowReportModal(true);
                            onHide();
                        }}
                    />
                </div>

                <div className="border-bottom-shades-300 mb-2"/>

                <div className="row p-0">
                    <div className="col-12 col-lg-6 d-flex justify-content-center align-items-center">
                        <ImageCardGrid preview={imagePreview} classNameWH="w-250px-h-250px"/>
                    </div>

                    <div className="col-12 col-lg-6 pr-lg-4">
                        <p className="fs-14px ibl-font-w-600 font-color-general-950 mb-2">{data?.fullName}</p>
                        <Section
                            title=""
                            leftIcon={EmailSubsectionChip}
                            leftText={data?.email}
                            rightIcon={PhoneLight}
                            rightText={data?.phoneNumber}
                        />
                        <Section
                            title={t("date_time")}
                            leftIcon={IconDateTimeCalendar}
                            leftText={getDateFormat(data?.entryDate, false, DATE_TIME_FORMAT_NAME_MODEL.monthWithDayYear)}
                            rightIcon={IconClockTable}
                            rightText={getTimeFormat(data?.entryDate)}
                        />
                        <Section
                            title={t("zone")}
                            leftIcon={IconMarkerTable}
                            leftText={data?.entryZoneName}
                        />
                        <Section
                            title={getAccessMethodLabel(data?.entryAccessMethodId || data?.accessMethodId, t)}
                            leftIcon={IconDevice}
                            leftText={data?.entryDeviceName}
                            horizontalLane={false}
                        />

                    </div>
                </div>
            </CustomCard>
        </CustomModal>
    );
};

export default AccessDetailsCardModal;
